function hexToRgb(h: string): [number, number, number] {
    const s = h.replace("#", "");
    const f = s.length === 3 ? s.split("").map(c => c + c).join("") : s;
    const n = parseInt(f, 16);
    return [(n >> 16) & 255, (n >> 8) & 255, n & 255];
}

function srgbToLin(c: number) {
    const x = c / 255;
    return x <= 0.03928 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
}

function relLum(hex: string) {
    const [r, g, b] = hexToRgb(hex);
    return 0.2126 * srgbToLin(r) + 0.7152 * srgbToLin(g) + 0.0722 * srgbToLin(b);
}

function contrastRatio(a: string, b: string) {
    const L1 = relLum(a), L2 = relLum(b);
    const [hi, lo] = L1 > L2 ? [L1, L2] : [L2, L1];
    return (hi + 0.05) / (lo + 0.05);
}

export function pickTextOn(bgHex: string | undefined | null): string {
    if (!bgHex) return "#000000"
    const contrastBlack = contrastRatio("#000000", bgHex);
    const contrastWhite = contrastRatio("#FFFFFF", bgHex);
    return contrastBlack >= contrastWhite ? "#000000" : "#FFFFFF";
}
